import { ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { I18nProvider } from './I18nProvider';
import { AuthProvider } from './AuthProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <I18nProvider>
            <AuthProvider>
              {children}
            </AuthProvider>
          </I18nProvider>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

// Export individual providers for direct use if needed
export { ErrorBoundary } from './ErrorBoundary';
export { QueryProvider } from './QueryProvider';
export { ThemeProvider } from './ThemeProvider';
export { I18nProvider } from './I18nProvider';
export { AuthProvider, useAuth } from './AuthProvider';